import { cva } from "class-variance-authority";

/**
 * Custom Cursor Variants
 *
 * V&A Waterfront Design System - Custom Cursor
 * Figma: https://www.figma.com/design/CV2ePEn9S0SSZ7T3AAPqF4/V-A-Waterfront---Website---Foundation-Design-System?node-id=12358-51481
 *
 * Types:
 * - drag: Pill with left/right chevrons (carousels/swipe areas)
 * - play: Circle with play arrow icon (video elements)
 */

export const cursorAreaVariants = cva(["relative cursor-none"], {
  variants: {},
  defaultVariants: {},
});

export const cursorElementVariants = cva(
  [
    "rounded-full",
    "flex items-center justify-center",
    "bg-[color:var(--cursor-background,var(--color-sunshine-yellow-500))]",
    "text-[color:var(--cursor-foreground,var(--color-deep-sea-blue-500))]",
    "backdrop-blur-[var(--cursor-backdrop-blur,0px)]",
    "shadow-[inset_0_0_0_var(--cursor-ring-width,0px)_var(--cursor-ring-color,transparent)]",
  ],
  {
    variants: {
      type: {
        drag: "p-4 desktop:px-4 desktop:py-9 size-[60px] desktop:size-auto desktop:w-auto desktop:h-auto gap-0 desktop:gap-4",
        play: "p-4 desktop:p-9 size-[60px] desktop:size-auto",
      },
    },
    defaultVariants: {
      type: "drag",
    },
  },
);
